import { render, staticRenderFns } from "./OtherContent.vue?vue&type=template&id=e0bd3148&scoped=true&"
import script from "./OtherContent.vue?vue&type=script&lang=js&"
export * from "./OtherContent.vue?vue&type=script&lang=js&"
import style0 from "./OtherContent.vue?vue&type=style&index=0&id=e0bd3148&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bd3148",
  null
  
)

export default component.exports